import hash from '../utils/hash'

const fonts = async () => {
  try {
    if (document.fonts && document.fonts.ready) {
      await document.fonts.ready
    }

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    if (!ctx) return { fonts: null }

    const testString = 'mmmmmmmmmmlli'
    const size = '72px'
    const baselines = ['monospace', 'sans-serif', 'serif']

    const baselineWidths: Record<string, number> = {}
    for (const b of baselines) {
      ctx.font = `${size} ${b}`
      baselineWidths[b] = ctx.measureText(testString).width
    }

    const detected: string[] = []
    for (let i = 0; i < fontList.length; i++) {
      const font = fontList[i]
      let found = false
      for (let j = 0; j < baselines.length; j++) {
        const b = baselines[j]
        ctx.font = `${size} "${font}",${b}`
        if (ctx.measureText(testString).width !== baselineWidths[b]) {
          found = true
          break
        }
      }
      if (found) detected.push(font)
    }

    detected.sort()
    return {
      fonts: {
        unique: detected.length,
        hash: hash(detected.join('|')),
        list: detected
      }
    }
  } catch {
    return { fonts: null }
  }
}

const fontList = [
  // Windows default
  'Arial',
  'Arial Black',
  'Arial Narrow',
  'Arial Rounded MT Bold',
  'Arial Unicode MS',
  'Bahnschrift',
  'Calibri',
  'Calibri Light',
  'Cambria',
  'Cambria Math',
  'Candara',
  'Comic Sans MS',
  'Consolas',
  'Constantia',
  'Corbel',
  'Courier',
  'Courier New',
  'Ebrima',
  'Franklin Gothic Medium',
  'Gabriola',
  'Gadugi',
  'Georgia',
  'HoloLens MDL2 Assets',
  'Impact',
  'Ink Free',
  'Javanese Text',
  'Leelawadee',
  'Leelawadee UI',
  'Lucida Console',
  'Lucida Sans Unicode',
  'Malgun Gothic',
  'Marlett',
  'Microsoft Himalaya',
  'Microsoft JhengHei',
  'Microsoft New Tai Lue',
  'Microsoft PhagsPa',
  'Microsoft Sans Serif',
  'Microsoft Tai Le',
  'Microsoft Uighur',
  'Microsoft YaHei',
  'Microsoft Yi Baiti',
  'MingLiU-ExtB',
  'Mongolian Baiti',
  'MS Gothic',
  'MV Boli',
  'Myanmar Text',
  'Nirmala UI',
  'Palatino Linotype',
  'Segoe MDL2 Assets',
  'Segoe Print',
  'Segoe Script',
  'Segoe UI',
  'Segoe UI Black',
  'Segoe UI Emoji',
  'Segoe UI Historic',
  'Segoe UI Light',
  'Segoe UI Semibold',
  'Segoe UI Symbol',
  'SimSun',
  'Sitka',
  'Sylfaen',
  'Symbol',
  'Tahoma',
  'Times',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'Webdings',
  'Wingdings',
  'Yu Gothic',
  'Yu Gothic UI',

  // macOS default
  'American Typewriter',
  'Andale Mono',
  'Apple Chancery',
  'Apple Color Emoji',
  'Apple SD Gothic Neo',
  'Apple Symbols',
  'AppleGothic',
  'AppleMyungjo',
  'Avenir',
  'Avenir Next',
  'Avenir Next Condensed',
  'Baskerville',
  'Big Caslon',
  'Bodoni 72',
  'Bodoni 72 Oldstyle',
  'Bodoni 72 Smallcaps',
  'Bradley Hand',
  'Brush Script MT',
  'Chalkboard',
  'Chalkboard SE',
  'Chalkduster',
  'Charter',
  'Cochin',
  'Copperplate',
  'DIN Alternate',
  'DIN Condensed',
  'Didot',
  'Futura',
  'Geneva',
  'Gill Sans',
  'Helvetica',
  'Helvetica Neue',
  'Herculanum',
  'Hoefler Text',
  'Lucida Grande',
  'Luminari',
  'Marker Felt',
  'Menlo',
  'Monaco',
  'Noteworthy',
  'Optima',
  'PT Mono',
  'PT Sans',
  'PT Sans Narrow',
  'PT Serif',
  'PT Serif Caption',
  'Palatino',
  'Papyrus',
  'Phosphate',
  'Rockwell',
  'SF Compact',
  'SF Mono',
  'SF Pro',
  'SF Pro Display',
  'SF Pro Text',
  'Savoye LET',
  'SignPainter',
  'Skia',
  'Snell Roundhand',
  'Trattatello',
  'Zapf Dingbats',
  'Zapfino',

  // iOS additional
  'Academy Engraved LET',
  'Al Nile',
  'Bodoni Ornaments',
  'Damascus',
  'Diwan Kufi',
  'Euphemia UCAS',
  'Farah',
  'GillSans',
  'Hiragino Maru Gothic ProN',
  'Hiragino Mincho ProN',
  'Hiragino Sans',
  'Kailasa',
  'Kefa',
  'Khmer Sangam MN',
  'Kohinoor Bangla',
  'Kohinoor Devanagari',
  'Kohinoor Telugu',
  'Lao Sangam MN',
  'Malayalam Sangam MN',
  'Mishafi',
  'Mukta Mahee',
  'Myanmar Sangam MN',
  'Noteworthy Light',
  'Oriya Sangam MN',
  'Sinhala Sangam MN',
  'Tamil Sangam MN',
  'Telugu Sangam MN',
  'Thonburi',

  // Linux (Ubuntu/Debian/Fedora defaults)
  'Bitstream Charter',
  'Cantarell',
  'DejaVu Sans',
  'DejaVu Sans Condensed',
  'DejaVu Sans Mono',
  'DejaVu Serif',
  'DejaVu Serif Condensed',
  'Droid Sans',
  'Droid Sans Mono',
  'Droid Serif',
  'FreeMono',
  'FreeSans',
  'FreeSerif',
  'Latin Modern Mono',
  'Liberation Mono',
  'Liberation Sans',
  'Liberation Sans Narrow',
  'Liberation Serif',
  'Linux Biolinum',
  'Linux Libertine',
  'Lohit Bengali',
  'Lohit Devanagari',
  'Lohit Gujarati',
  'Lohit Tamil',
  'Luxi Mono',
  'Luxi Sans',
  'Luxi Serif',
  'Nimbus Mono L',
  'Nimbus Roman No9 L',
  'Nimbus Sans L',
  'Padauk',
  'STIX',
  'TakaoGothic',
  'TakaoMincho',
  'Ubuntu',
  'Ubuntu Condensed',
  'Ubuntu Light',
  'Ubuntu Mono',
  'URW Bookman L',
  'URW Chancery L',
  'URW Gothic L',
  'URW Palladio L',

  // Android defaults
  'Carrois Gothic',
  'Coming Soon',
  'Cutive Mono',
  'Dancing Script',
  'Noto Color Emoji',
  'Noto Sans',
  'Noto Sans Arabic',
  'Noto Sans CJK JP',
  'Noto Sans CJK KR',
  'Noto Sans CJK SC',
  'Noto Sans CJK TC',
  'Noto Sans Devanagari',
  'Noto Sans Hebrew',
  'Noto Sans Mono',
  'Noto Sans Symbols',
  'Noto Sans Thai',
  'Noto Serif',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',

  // MS Office common
  'Algerian',
  'Baskerville Old Face',
  'Bauhaus 93',
  'Bell MT',
  'Berlin Sans FB',
  'Bernard MT Condensed',
  'Blackadder ITC',
  'Bodoni MT',
  'Book Antiqua',
  'Bookman Old Style',
  'Bookshelf Symbol 7',
  'Bradley Hand ITC',
  'Britannic Bold',
  'Broadway',
  'Brush Script MT Italic',
  'Californian FB',
  'Calisto MT',
  'Castellar',
  'Centaur',
  'Century',
  'Century Gothic',
  'Century Schoolbook',
  'Chiller',
  'Colonna MT',
  'Cooper Black',
  'Copperplate Gothic Bold',
  'Copperplate Gothic Light',
  'Curlz MT',
  'Edwardian Script ITC',
  'Elephant',
  'Engravers MT',
  'Eras Bold ITC',
  'Eras Demi ITC',
  'Eras Light ITC',
  'Eras Medium ITC',
  'Felix Titling',
  'Footlight MT Light',
  'Forte',
  'Freestyle Script',
  'French Script MT',
  'Garamond',
  'Gigi',
  'Gill Sans MT',
  'Gill Sans MT Condensed',
  'Gloucester MT Extra Condensed',
  'Goudy Old Style',
  'Goudy Stout',
  'Haettenschweiler',
  'Harlow Solid Italic',
  'Harrington',
  'High Tower Text',
  'Imprint MT Shadow',
  'Informal Roman',
  'Jokerman',
  'Juice ITC',
  'Kristen ITC',
  'Kunstler Script',
  'Lucida Bright',
  'Lucida Calligraphy',
  'Lucida Fax',
  'Lucida Handwriting',
  'Lucida Sans',
  'Lucida Sans Typewriter',
  'Magneto',
  'Maiandra GD',
  'Matura MT Script Capitals',
  'Mistral',
  'Modern No. 20',
  'Monotype Corsiva',
  'MS Outlook',
  'MS Reference Sans Serif',
  'MS Reference Specialty',
  'Niagara Engraved',
  'Niagara Solid',
  'OCR A Extended',
  'Old English Text MT',
  'Onyx',
  'Palace Script MT',
  'Parchment',
  'Perpetua',
  'Perpetua Titling MT',
  'Playbill',
  'Poor Richard',
  'Pristina',
  'Rage Italic',
  'Ravie',
  'Rockwell Condensed',
  'Rockwell Extra Bold',
  'Script MT Bold',
  'Showcard Gothic',
  'Snap ITC',
  'Stencil',
  'Tempus Sans ITC',
  'Tw Cen MT',
  'Tw Cen MT Condensed',
  'Viner Hand ITC',
  'Vivaldi',
  'Vladimir Script',
  'Wide Latin',

  // Adobe common
  'Adobe Arabic',
  'Adobe Caslon Pro',
  'Adobe Devanagari',
  'Adobe Fan Heiti Std',
  'Adobe Fangsong Std',
  'Adobe Garamond Pro',
  'Adobe Gothic Std',
  'Adobe Hebrew',
  'Adobe Heiti Std',
  'Adobe Kaiti Std',
  'Adobe Ming Std',
  'Adobe Myungjo Std',
  'Adobe Naskh',
  'Adobe Song Std',
  'Minion Pro',
  'Myriad Pro',
  'Myriad Web Pro',
  'Source Code Pro',
  'Source Sans Pro',
  'Source Serif Pro',

  // Generic / misc common
  'Century Schoolbook L',
  'DejaVu LGC Sans',
  'Fira Code',
  'Fira Mono',
  'Fira Sans',
  'Inconsolata',
  'Inter',
  'JetBrains Mono',
  'Lato',
  'Merriweather',
  'Montserrat',
  'Noto Emoji',
  'Open Sans',
  'Oswald',
  'Poppins',
  'Raleway',
  'Roboto Light',
  'Source Han Sans',
  'Work Sans'
]

export default fonts
